
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component({})
export default class Button extends Vue {
  @Prop({ default: 'primary' })
  type! : string

  @Prop({ default: false })
  link! : boolean

  @Prop({ default: null })
  icon! : string

  @Prop({ default: false })
  disabled! : boolean

  @Prop({ default: false })
  inline! : boolean

  click () {
    if (this.disabled) {
      return
    }

    this.$emit('click')
  }

  get cssClasses () {
    const result: {[name: string] : boolean} = {
      'pf-c-button': true
    }

    result[`pf-m-${this.type}`] = true

    if (this.link) {
      result['pf-m-link'] = true
    }

    if (this.inline) {
      result['pf-m-inline'] = true
    }

    return result
  }
}
